import React, { Component, Fragment } from 'react';
import { firstDayOfYear } from '../../../../commonModules/utils/statsFunctions';
import { InputSelect, InputSelectMulti } from '../../../../commonModules/interface/form-input-inline';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { isEmpty } from 'lodash';

export const filterShop = (list, selectShop = {label: "", value: ""}) => {
   
    if( !isEmpty(selectShop.value)) {
        list = list.filter( item => item.shop_id === selectShop.value)
    }
    if( Array.isArray(selectShop) && !isEmpty(selectShop) ) {
        let itemList = selectShop.map(item => item.value )
        list = list.filter( item => itemList.includes(item.shop_id))
    }

    return list
}
export const filterShopReappro = (list, src = {label: "", value: ""}, dest = {label: "", value: ""}) => {
   
    if( !isEmpty(src.value) && !isEmpty(dest.value)) {
        list = list.filter( item => item.shop_id === src.value &&  item.shop_dest === dest.value)
    } else if( !isEmpty(src.value)) {
        list = list.filter( item => item.shop_id === src.value)
    } else if( !isEmpty(dest.value)) {
        list = list.filter( item => item.shop_dest === dest.value)
    }
    if( Array.isArray(src) && !isEmpty(src) && Array.isArray(dest) && !isEmpty(dest) ) {
        let srcList = src.map(item => item.value )
        let destList = dest.map(item => item.value )
        list = list.filter( item => srcList.includes(item.shop_id) && destList.includes(item.shop_dest) )
    } else if( Array.isArray(src) && !isEmpty(src) ) {
        let srcList = src.map(item => item.value )
        list = list.filter( item => srcList.includes(item.shop_id))
    } else if( Array.isArray(dest) && !isEmpty(dest) ) {
        let destList = dest.map(item => item.value )
        list = list.filter( item => destList.includes(item.shop_dest))
    }

    return list
}
export const filterShopCustom = (list, field, selectShop = {label: "", value: ""}) => {
   
    console.log('==================SELECT SHOP==================');
    console.log({selectShop});
    console.log('=================SELECT SHOP===================');
    if( !isEmpty(selectShop.value)) {
        list = list.filter( item => item[field] === selectShop.value)
    }
    if( Array.isArray(selectShop) && !isEmpty(selectShop) ) {
        let itemList = selectShop.map(item => item.value )
        list = list.filter( item => itemList.includes(item[field]))
    }

    return list
}

class ShopFilter extends Component {
    state = {  }
    createShopList = (field = "selectShop") => {
        const list = [{value: "", label:"Tous les Magasins"}]
        const { SHOPS } = this.props
        if( !isEmpty(SHOPS) ){
            Object.values(SHOPS).forEach( shop => { 
                list.push ({
                    value: shop.id, 
                    label: shop.name,
                    disabled: Array.isArray(this.props[field]) && !!this.props[field].find(element => element.value === shop.id)
                })
            })
        } 
        return list
    }
    
    render() {
        let shopsAll = this.createShopList(this.props.fieldName)
        return (
            <InputSelectMulti
                label={this.props.label || "Filtrer les magasins"}
                name={this.props.fieldName}
                options={this.props.shops || shopsAll }
                value={this.props.value}
                onChange={(option) => this.props.handleSelect(option, this.props.fieldName || "selectShop")}
                isMulti
                id={this.props.id || "shopSelect"}
            /> 
        );
    }
}

function mapStateToProps(state){
    return {
        // PRODUCTS: state.inventory.products,
        SHOPS: state.inventory.shops,
    }
}

function mapDispatchToProps(dispatch){
    return bindActionCreators({
 }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(ShopFilter);
